import styled from 'styled-components';
import { RedTigerWidgetHitAreaDefaultBox } from './red-tiger-widget-hit-area.default.box';


export const RedTigerWidgetHitAreaCasino777Box = styled(RedTigerWidgetHitAreaDefaultBox)`
    cursor: default;
`;